import {defaultMinValue, descriptionFieldRegex} from './const';

export const capitalizeFirstLetter = (string) => {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
};

export const validateInfiniteSearchField = (searchData) => {
  if (searchData.length <= 255 && descriptionFieldRegex.test(searchData)) {
    return true;
  }
  return false;
};


// helper for yup transform function
export function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
}



export const getRiskColor = (dataIndex) => {
  let variant;
  if (dataIndex !== undefined) {
    if (dataIndex === 'Nizak' || dataIndex === 'Low') {
      variant = 'green'
    } else if (dataIndex === 'Visok' || dataIndex === 'High') {
      variant = 'orange'
    }else if(dataIndex === 'Umjeren' || dataIndex === 'Medium') {
      variant = 'yellow'
    }else if(dataIndex === 'Vrlo nizak' || dataIndex === 'Very low') {
      variant = 'pineGreen'
    }else if(dataIndex === 'Veoma nizak' || dataIndex === 'Very low') {
      variant = 'pineGreen'
    }else if(dataIndex === 'Nizak do umjeren' || dataIndex === 'Low to Moderate') {
      variant = 'oliveGreen'
    }else if(dataIndex === 'Umjeren do visok' || dataIndex === 'Moderate to High') {
      variant = 'peach'
    }else if(dataIndex === 'Vrlo visok' || dataIndex === 'Very high') {
      variant = 'red'
    }else if(dataIndex === 'Veoma visok' || dataIndex === 'Very high') {
      variant = 'red'
    }
  }
  return variant;
}

export const RISK_COLOR_MAP = {
  // Lovcen Bank
  RED: "#f5501f",//very high
  YELLOW: "#f59a1f",//medium
  ORANGE: "#FFBF00",//high
  GREEN: "#37c35c",//low
  PINE_GREEN: "#027148",// very low

// IRF
  OLIVE_GREEN: "#8FA85A",       //low to moderate
  PEACH: "#EFB89B",             //moderate to high
};

export const testValidNumber = (value,isOptional = false) => {
  if (!value) {
    return isOptional;
  }
  const validNumberFormat = RegExp(/^(\d+)([.,]\d+)?$/);

  const valueWithoutThousandsSeparator = value.replace(/\./g, '');

  if (!validNumberFormat.test(valueWithoutThousandsSeparator)) {
    return false;
  }

  const normalizedValue = valueWithoutThousandsSeparator.replace(',', '.');

  return !isNaN(parseFloat(normalizedValue));
}

export const testIsGreaterThanMin = (value,minValue) => {
  if(value.length > 0 && value <= 0) {
    const normalizedValue = value.replace(',', '.');
    return parseFloat(normalizedValue) >= minValue;
  }else{
    return true;
  }
}
export const maxDecimalNumber = (value) => {
  const valueWithoutThousandsSeparator = value.replace(/\./g, '');

  const decimalMatch = valueWithoutThousandsSeparator.match(/[.,](\d{1,})$/);
  if (decimalMatch && decimalMatch[1].length > 2) {
    return false;
  }
  return true;
}

export const onDecimalNumberInputChange = (e,setValue,name) => {
  e.target.value = formatNumberInput(e.target.value);
  setValue(name, formatNumberInput(e.target.value));
}

export const parseFormattedNumber = (value) => {
  if (value === '' || value === null || value === undefined) {
    return "";
  }
  if(typeof value === 'string') {
    if(Number(value) < 1) {
      return Number(value)
    }
    return parseFloat(value
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/\s+/g, ''));
  } else {
    return value;
  }
}
export const formatNumber = (value) => {
  if (value === null || value === undefined) return '';

  return value
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
export const setFormattedDefault = (fieldName, value,setValue) => {
  if (!value && value !== 0) return;

  const formatted = formatNumberInput(
      formatNumberForDisplay(value).includes(',')
          ? formatNumberForDisplay(value)
          : formatNumberForDisplay(value) + ',00',
      2
  );

  setValue(fieldName, formatted);
};

export const formatNumberInput = (value,limitDecimalPart = 0) => {
    const decimalSeparator = value.includes(',') ? ',' : null;

  value = value.replace(/[^0-9.,-]/g, '');

  if (value.includes('-')) {
    value = value.replace(/-/g, '');
    value = '-' + value;
  }

  if (value.includes(',') && value.includes('.')) {
    value = value.replace(/,/g, '.');
    const lastDotIndex = value.lastIndexOf('.');
    value = value.substring(0, lastDotIndex) + ',' + value.substring(lastDotIndex + 1);
  }

    let normalizedValue = value.replace(/\./g, '').replace(',', '.');

    let [integerPart, decimalPart] = normalizedValue.split('.');

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if(limitDecimalPart > 0) {
      return decimalSeparator ? `${integerPart}${decimalSeparator}${decimalPart.substring(0,limitDecimalPart) || ''}` : integerPart;
    }else {
      return decimalSeparator ? `${integerPart}${decimalSeparator}${decimalPart || ''}` : integerPart;
    }
}

export const handlePasteAndValidate = async (e, setValue, trigger, fieldName) => {
  e.preventDefault();

  const pastedValue = e.clipboardData.getData('Text');
  const formattedValue = formatNumberInput(pastedValue, 2);

  setValue(fieldName, formattedValue);
  await trigger(fieldName);
};



export const formatNumberForDisplay = (value) => {
  if (value == null) return '';
  if(typeof value === 'string') return value;
  return String(value).replace('.', ',');
}


export const getRatingColor = (dataIndex) => {
  let color;
  if (dataIndex !== undefined) {
    dataIndex < 5 ? color = "green" : (dataIndex >= 5 && dataIndex < 10) ? color = "orange" : color = "red"
  }
  return color;
}

